import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import unsortedIcon from "../../assets/images/png/upDown.png";
import sortedIcon from "../../assets/images/png/sortedIcon.png";
import sortedAtoz from "../../assets/images/png/descSortIcon.png";
import PopupMenu from "../PopupMenu/PopupMenu";
import SortFilterList from "../SortFilterList/SortFilterList";
import { memo } from "react";
const Table3 = ({
  data,
  columns,
  tableClass,
  EmptyState,
  EmptyStateBody,
  forBorderClass,
  handleSort,
  sortKey,
  isAscending,
  showColumnsOnly,
  elementToPush,
  forThirdTd,
  single_row,
  classUnrealised,
  isTableLoader,
  justifyContent,
  d,
}) => {
  const [isOption4Col, setIsOption4Col] = useState(false);
  const [borderHeightWidth, setBorderHeightWidth] = useState({
    height: 0,
    width: 0,
  });

  const HeaderComp = ({
    pWidth,
    classn,
    index,
    width,
    minWidth,
    sortable,
    isMultipleSort,
    key,
    label,
    multiSortBox,
    handleSorting,
    position,
    forArrowCheckComp,
    sortKeyComp,
    justifyContent,
  }) => {
    const [niftyMenu, setNiftyMenu] = useState(false);

    const handleClick = (key) => {
      setNiftyMenu(true);
    };
    const handleNifty = (data, index) => {
      handleSort(data.item.key);
    };
    return (
      <div
        className={
          sortable
            ? "header_cell cursor blueTextColor"
            : "header_cell blueTextColor"
        }
        onClick={() => handleClick(key)}
      >
        <PopupMenu
          position={position}
          type="multiSort"
          setOpen={setNiftyMenu}
          open={niftyMenu}
          MenuContent={() => (
            <SortFilterList
              list={multiSortBox}
              onClick={(data, index) => handleNifty(data, index)}
              title="Sort by"
              isAscending={isAscending}
              sortKey={sortKey}
              key={key}
            />
          )}
        >
          <div style={{ display: "flex", gap: "4px" }}>
            <p style={pWidth ? { maxWidth: pWidth } : {}}>{label}</p>
            {sortable && (
              <div
                className="accordion_table_header_child_icon"
                style={{ alignSelf: "center" }}
              >
                <img
                  src={
                    isAscending && forArrowCheckComp?.includes(sortKeyComp)
                      ? sortedIcon
                      : !isAscending && forArrowCheckComp?.includes(sortKeyComp)
                        ? sortedAtoz
                        : !forArrowCheckComp?.includes(sortKeyComp)
                          ? unsortedIcon
                          : unsortedIcon
                  }
                  alt="sort"
                />
              </div>
            )}
          </div>
        </PopupMenu>
      </div>
    );
  };

  const headerRenderer = (
    {
      label,
      key,
      sortable,
      width,
      minWidth,
      classn,
      customHeaderRenderer,
      isMultipleSort,
      multiSortBox,
      position,
      forArrowCheck,
      optionNum,
      pStyle,
      tdStyle,
      currentSortKey,
      pWidth,
      justifyContent,
    },
    index,
  ) => {
    if (customHeaderRenderer) {
      return customHeaderRenderer({
        label,
        key,
        sortable,
        width,
        minWidth,
        classn,
        optionNum,
        tdStyle,
        pStyle,
        currentSortKey,
      });
    } else {
      return (
        <th
          aria-sort={
            sortKey === key
              ? !isAscending
                ? "Ascending"
                : "Descending"
              : undefined
          }
          className={
            classn ? classn : index === 3 && forThirdTd ? forThirdTd : ""
          }
          style={{ width: width, minWidth: minWidth }}
        >
          {isMultipleSort === undefined ? (
            <>
              {sortable ? (
                <button
                  style={justifyContent ? { justifyContent } : {}}
                  className={"header_cell cursor blueTextColor header-button"}
                  onClick={() => sortable && handleSort(key)}
                >
                  <>
                    <p>{label}</p>
                    <>
                      <img
                        aria-hidden={true}
                        src={
                          isAscending && sortKey === key
                            ? sortedIcon
                            : !isAscending && sortKey === key
                              ? sortedAtoz
                              : sortKey !== key
                                ? unsortedIcon
                                : unsortedIcon
                        }
                        alt="sort"
                      />
                    </>
                  </>
                </button>
              ) : (
                <div
                  style={justifyContent ? { justifyContent } : {}}
                  className={
                    sortable
                      ? "header_cell cursor blueTextColor"
                      : "header_cell blueTextColor"
                  }
                  onClick={() => sortable && handleSort(key)}
                >
                  <>
                    <p>{label}</p>
                  </>
                </div>
              )}
            </>
          ) : (
            <HeaderComp
              classn={classn}
              pWidth={pWidth}
              index={index}
              width={width}
              minWidth={minWidth}
              sortable={sortable}
              isMultipleSort={isMultipleSort}
              key={key}
              label={label}
              multiSortBox={multiSortBox}
              position={position}
              sortKeyComp={sortKey}
              forArrowCheckComp={forArrowCheck}
            />
          )}
        </th>
      );
    }
  };

  const getRowData = () => {
    return data;
  };

  useLayoutEffect(() => {
    if (
      columns?.[0]?.key !== "instrument_name" &&
      columns?.[0]?.label?.includes("Qty")
    ) {
      setIsOption4Col(true);
    }
    // eslint-disable-next-line
  }, []);

  const tbodyRef = useRef(null);

  useEffect(() => {
    const handleResize = () =>
      setBorderHeightWidth({
        height: tbodyRef?.current?.clientHeight,
        width: tbodyRef?.current?.clientWidth,
      });

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      {(!!data && !!data.length) || showColumnsOnly ? (
        <>
          <table
            className={`table ${tableClass ? tableClass : "custom_table"}`}
          >
            <thead>
              <tr>
                {!!data && !!data.length ? (
                  columns?.map(headerRenderer)
                ) : showColumnsOnly ? (
                  columns?.map(headerRenderer)
                ) : (
                  <>hello</>
                )}
              </tr>
            </thead>
            <div
              style={{
                height: borderHeightWidth.height
                  ? borderHeightWidth.height
                  : tbodyRef?.current?.clientHeight,
                width: borderHeightWidth.width
                  ? borderHeightWidth.width
                  : tbodyRef?.current?.clientWidth,
              }}
              className="ledger_report_detailed_table_border"
            />
            <tbody ref={tbodyRef}>
              {(!showColumnsOnly || data) &&
                getRowData().map((eachRow, index) => {
                  return (
                    <tr
                      className={`${
                        index === data?.length - 2 ? forBorderClass : ""
                      } ${data.length === 1 ? "single_row" : ""}`}
                    >
                      {columns.map((column, idx) => {
                        return (
                          <td
                            style={
                              classUnrealised && idx === columns.length - 4
                                ? { paddingRight: "5px" }
                                : isOption4Col &&
                                    idx === 0 &&
                                    eachRow?.actualWholeObject?.investmentreturn
                                      ?.commitment_val?.amount?.actual_value
                                  ? { padding: "15px 18px 30px 10px" }
                                  : eachRow?.actualWholeObject?.investmentreturn
                                        ?.commitment_val?.amount
                                        ?.actual_value && isOption4Col
                                    ? { paddingBottom: "30px" }
                                    : {}
                            }
                          >
                            {column.cellRenderer
                              ? column.cellRenderer(
                                  eachRow[column.key],
                                  eachRow,
                                  column.key,
                                  index,
                                )
                              : eachRow[column.key]}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              {elementToPush !== undefined &&
                elementToPush?.map((eachRow, index) => {
                  return (
                    <tr className="total_row">
                      {columns.map((column, idx) => {
                        return (
                          <td>
                            {(idx === 0 || idx === 4 || idx === 6) &&
                            column.cellRenderer
                              ? column.cellRenderer(
                                  eachRow[column.key],
                                  eachRow,
                                  column.key,
                                  index,
                                  "total",
                                )
                              : ""}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
            </tbody>
          </table>
          {showColumnsOnly &&
            (data === undefined || data.length === 0) &&
            !!EmptyStateBody &&
            EmptyStateBody}
        </>
      ) : EmptyState ? (
        <>{EmptyState}</>
      ) : (
        <></>
      )}
    </>
  );
};

export default memo(Table3);
